import * as React from "react";
import { forwardRef } from "react";
const Svg16Px = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.5 9.5A6 6 0 0 1 6.5 2.5a6 6 0 1 0 7 7z", fill: "currentColor" }));
const ForwardRef = forwardRef(Svg16Px);
export default ForwardRef;
